import React from 'react';
import { Container, Typography, Box, Grid, CircularProgress } from '@mui/material';
import Banner from "../../components/Banner";
import BannerHub from './../../components/BannerHub.js';
import CarouselArticulos from './../../components/CarouselArticulos';
import { useEffect, useState } from 'react';
import { fetchAllBlogPosts } from './../../components/wordpressUtils';
import AlternatingInfoBlock from "./../../components/AlternatingInfoBlock";
import CallToActionSection from "./../../components/CallToActionSection.js";
import FeatureCard from "./../../components/FeatureCard.js";

export default function Empresa() {
  const [isLoadingArticles, setIsLoadingArticles] = useState(true);
  const [wordpressArticles, setWordpressArticles] = useState([]); 
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoadingArticles(true);
        const wpArticles = await fetchAllBlogPosts();
        setWordpressArticles(wpArticles);
      } catch (err) {
        console.error('Error al obtener artículos:', err);
      } finally {
        setIsLoadingArticles(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Container sx={{ margin: '0', padding: '0 !important', maxWidth: '100vw !important' }}>
      <Banner
        titleBackgroundColor="#0A6274"
        backgroundImage="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745515680/ebm/banner-empresa_q4aw0t.png"
        extraContent={
          <Box
            sx={{

              bottom: 0,
              left: 0,
              maxWidth: { xs: '350px', sm: '500px', md: '600px' },
              paddingLeft: { xs: '2.2rem', sm: '7.2rem' },
              padding: "10px",
              textAlign: "justify",
              placeContent: 'inherit'

            }}
          >
            <Typography sx={{ color: 'white', fontSize: { xs: '14px', sm: '16px' }, textAlign: 'left', textShadow: '0px 2px 10px rgb(0,0,0,0.5)', letterSpacing: 2 }}>EJES DE ACCIÓN</Typography>
          </Box>
        }
        title="La empresa"
        subtitle={
          <Box sx={{
            padding: { xs: "2rem 2rem", sm: "2.2rem 7.2rem" },
            textAlign: { sm: "justify" },
            width: '100%', maxWidth: '840px', marginBottom: '14vh'
          }}>
            <Typography sx={{ fontSize: { xs: '12px', sm: '14px', md: '16px' }, textShadow: '0px 2px 10px rgb(0,0,0,0.5)', maxWidth: { sm: '450px', md: '600px' } }}>
              Te ayudamos a dar cada paso necesario para que tu empresa no solo prospere hoy, sino que <b>trascienda y continúe dejando huella generación tras generación.</b></Typography>
          </Box>
        }
        variant="bottom-left"
        
      />

      <Box
        sx={{
          backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1745516801/ebm/fondo-empresa_fhtxrz.png)',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          width: '100%',
          overflowX: 'hidden',
          py: 8,
        }}
      >
        <Grid container sx={{ maxWidth: '1300px', mx: 'auto', px: { xs: 2, sm: 4, md: 6, lg: 8 } }} spacing={4} alignItems="flex-start">
          {/* Columna izquierda: título + texto blanco */}
          <Grid item xs={12} lg={6}>
            <Typography
              sx={{
                fontSize: { xs: '22px', lg: '28px' },
                color: '#D4A76A',
                mb: 4,
                ml: { lg: '-50px' } // Mueve el título más a la izquierda
              }}
            >
              La <strong>institucionalización</strong> transforma tu empresa en una{" "}
              <strong>organización sólida</strong> y preparada para el{" "}
              <strong>futuro</strong>.
            </Typography>

            <Typography
              sx={{
                color: 'white',
                textAlign: 'justify',
                fontSize: '14px',
                maxWidth: '600px',
                ml: { lg: '-50px' } // Mueve el texto más a la izquierda
              }}
            >
              Compartimos tu visión de trascendencia y entendemos lo valioso que es el legado que has construido. Nos importa el futuro de tu empresa y queremos ayudarte a sentar las bases de su <strong>continuidad.</strong>
              <br /><br />
              No solo buscamos optimizar procesos, sino establecer un <strong>marco que te permita tomar decisiones estratégicas</strong> con confianza y claridad.
              <br /><br />
              Convirtiendo el esfuerzo de hoy en el éxito de mañana y asegurando un legado duradero para quienes vienen después de ti.
            </Typography>
          </Grid>

          {/* Columna derecha: imagen de la pirámide */}
          <Grid item xs={12} lg={6}
            sx={{
              display: 'flex',
              justifyContent: { xs: 'center', lg: 'flex-start' },
              pl: { lg: 0 },
              ml: { lg: 0 } // Mueve la imagen más a la izquierda
            }}
          >
            <Box
              component="img"
              src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190610/ebm/piramideSeccionEmpresa_oyfnj6.png"
              alt="Pirámide institucionalización"
              sx={{
                width: '120%',
                maxWidth: '772px',
              }}
            />
          </Grid>
        </Grid>

        {/* Resto del contenido... */}
        <Box sx={{ color: 'white', display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' }, px: 2, maxWidth: '1300px', mx: 'auto' }}>
          <Typography sx={{ fontSize: { xs: '20px', sm: '28px' }, pl: 2, pt: 4 }}>El valor de la</Typography>

          <Typography
            sx={{
              mb: 4,
              position: 'relative',
              px: 2,
              borderRadius: '50rem',
              background: 'linear-gradient( rgba(10, 98, 116, 0.2), rgba(10, 98, 116, 0.5))',
              fontSize: { xs: '20px', sm: '28px' },
              display: 'inline-block',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              boxShadow: '0px 2px 10px rgba(0,0,0,0.5)',
              transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
              zIndex: 1,
              '&::before': {
                content: '""',
                position: 'absolute',
                inset: 0,
                padding: '1px',
                borderRadius: '50rem',
                background: 'linear-gradient(180deg, rgb(0,255,255,0.5), rgba(10, 98, 116, 0))',
                WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                WebkitMaskComposite: 'xor',
                maskComposite: 'exclude',
                zIndex: -1,
                transition: 'opacity 0.3s ease',
              },
            }}
          >
            institucionalización{" "}<Box component="span" sx={{ fontWeight: 700 }}>empresarial</Box>
          </Typography>
        </Box>

        <Grid container sx={{ color: 'white', maxWidth: '1185px', justifyContent: 'center', mx: 'auto', py: 10 }}>
          <FeatureCard
            icon="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745521650/ebm/operacion-icon_s0jf2q.png"
            title="Operación continua y estable"
            description="Estructuras que fomentan que la empresa funcione sin interrupciones, incluso en momentos de cambio o incertidumbre."
          />
          <FeatureCard
            icon="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745521650/ebm/eficiencia-icon_wao1xd.png"
            title="Eficiencia optimizada"
            description="Mejora la gestión global, agilizando procesos y maximizando los recursos para alcanzar tus objetivos de manera más efectiva."
          />
          <FeatureCard
            icon="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745521650/ebm/decisiones-icon_dommkm.png"
            title="Toma de decisiones estratégica"
            description="Con estructuras y mecanismos bien definidos, las decisiones se toman de manera informada y alineadas con los objetivos, reduciendo impulsos y riesgos."
          />
          <FeatureCard
            icon="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745521650/ebm/profesionalizacion-icon_oz7x4h.png"
            title="Mayor profesionalización"
            description="Fomenta una cultura empresarial más profesional, mejorando la calidad de la gestión y la relación con empleados, clientes y socios."
          />
          <FeatureCard
            icon="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745521650/ebm/transicion-icon_mroadc.png"
            title="Transición generacional"
            description="Reduce conflictos y asegura una transición fluida del liderazgo a nuevas generaciones, protegiendo el legado y el patrimonio."
          />
        </Grid>
      </Box>

      <CallToActionSection
        gradient="linear-gradient(to right, #2f2f2f, #1a1a1a)"
        title="¡No dejes el futuro de tu empresa al azar!"
        description={`Contacta a un consultor y lleva tu negocio al siguiente nivel con <strong>estructuras sólidas, decisiones estratégicas y un crecimiento sostenible. </strong>`}
        buttonText="Agenda una cita"
        buttonLink="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2eVA-xB-1w0bULc68zTMQ5dWAK4AP9Ow9P6r6QQl4DFZkqdrRENaPyWxRyLbAtrmocL908Fkfl"
        image={'https://res.cloudinary.com/dhoyyqszi/image/upload/v1745598584/ebm/empresa-callToAction_mackhm.png'}
      />

      {/* Resto del componente... */}
      <Box sx={{ pt: 10 }}>
        <Typography sx={{ color: '#0A6274', textAlign: 'center', fontSize: '32px' }}>Nuestros <b>servicios</b></Typography>
        <Typography sx={{ letterSpacing: 1, textAlign: 'center', fontSize: '20px', textTransform: 'uppercase' }}>Institucionalizando la organización</Typography>

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Sistema de Gobierno Corporativo"
          subtitle="PROFESIONALIZACIÓN DEL CONTROL Y TOMA DE DECISIONES"
          description={
            <>
              Implementación de un sistema profesionalizado de control y vigilancia, definiendo directrices para el funcionamiento de los órganos clave, diseñando una estructura eficiente y estableciendo procesos formales de rendición de cuentas.    <br />
              <br />
              Con un gobierno corporativo solido, tu empresa podrá maximizar su valor a largo plazo al tomar decisiones estratégicas y beneficiosas y reducir riesgos.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1745436292/ebm/empresa-img-1_giynut.png"
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Gestión financiera estratégica"
          subtitle="TRANSFORMANDO LA DIRECCIÓN FINANCIERA"
          description={
            <>
              Fortalecemos la dirección financiera de tu empresa con un enfoque estratégico, no solo operativo. Actuamos como el copiloto del director financiero para convertir la información contable en inteligencia de negocios útil, clara y accionable.
              <br /><br />
              Institucionalizamos la función financiera mediante procesos, indicadores y controles que protegen tu liquidez y respaldan cada decisión con información confiable.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101498/ebm/empresa-img-2_lkeqhp.png"
          reverse
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Estructuración y elaboración de planes de negocio"
          subtitle="Transforma tu visión en una hoja de ruta ejecutable"
          description={
            <>
              Diseñamos el Playbook de tu próxima etapa de crecimiento. Ya sea para lanzar una nueva línea de negocio, estructurar una empresa en crecimiento o levantar capital de riesgo, vamos más allá de un simple documento: realizamos un ejercicio de ingeniería estratégica.
              <br /><br />
              Validamos tu modelo de negocio, buscando mitigar riesgos y demostramos explicitamente su rentabilidad futura.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101513/ebm/empresa-img.3_pefyur.png"
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Elaboración, evaluación y modelado de proyectos de inversión"
          subtitle="Convierte tu idea en una decisión de inversión"
          description={
            <>
              Estructuramos y/o evaluamos tu iniciativa de negocio buscando demostrar su viabilidad técnica y financiera.
              <br /><br />
              Transformamos tu visión en un caso de inversión confiable, con proyecciones financieras, análisis de riesgos y métricas de rentabilidad.
              <br /><br />
              Actuamos como el filtro analítico entre la oportunidad y la exigencia técnica que demandan inversionistas.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101518/ebm/empresa-img-4_n9rnpx.png"
          reverse
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Plan de sucesión de la dirección"
          subtitle="Fortaleciendo la dirección y toma de decisiones"
          description={
            <>
              Está diseñado para garantizar la continuidad y estabilidad del liderazgo en tu organización. Ofrecemos un acompañamiento integral y asesoramiento estratégico en el diseño e implementación de planes de sucesión enfocados en la dirección general.
              <br /><br />
              Este proceso incluye la identificación de talento clave, la preparación del sucesor y la planificación de una transición estructurada y eficiente, siempre alineada con los objetivos de largo plazo de la empresa.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101523/ebm/empresa-img-5_d3iv3f.png"
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Medición y control de riesgos financieros"
          subtitle="ASEGURA EL EXITO DEL MAÑANA"
          description={
            <>
              Identificamos, evaluamos y gestionamos los riesgos que pueden impactar tu liquidez, rentabilidad y estabilidad financiera. Implementamos métricas, escenarios y mecanismos de control que permiten anticipar desviaciones y reducir vulnerabilidades.
              <br /><br />
              La gestión del riesgo no es reaccionar ante una crisis, es prevenirla con información y estructura.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101528/ebm/empresa-img-6_dmrxda.png"
          reverse
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Sistema de monitoreo financiero"
          subtitle="Fortaleciendo la dirección y toma de decisiones"
          description={
            <>
              Diseñamos e implementamos un mecanismo de monitoreo y control financiero que convierte la información en inteligencia para la toma de decisiones.
              <br /><br />
              Transformamos tus datos en un tablero de control con indicadores de desempeño (KPIs) que permiten a la Dirección, al Consejo y a los accionistas visualizar en tiempo real la salud financiera, la liquidez y la rentabilidad del negocio. Porque las decisiones de alto nivel deben basarse en información clara, estructurada y oportuna.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101535/ebm/empresa-img-7_efrvsl.png"
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Elaboración de Plan de Contingencia: Seguro de hombre clave"
          subtitle="No pongas en riesgo tu deducción fiscal"
          description={
            <>
              Muchos agentes de seguros te venden la póliza del &quot;Hombre Clave&quot; prometiendo beneficios fiscales inmediatos, pero omiten el requisito más estricto de la autoridad (Art. 27 LISR): debes contar con un Plan de Contingencia Financiera formal y justificar la Razón de Negocios. En EBM Consultores creamos el expediente de defensa que blinda tu deducción.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101542/ebm/empresa-img-8_v89wzu.png"
          reverse
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Diseño de estructura directiva"
          subtitle="optimización del liderazgo"
          description={
            <>
              Buscamos que tu empresa cuente con los líderes ideales en los roles clave para impulsar la acción y alcanzar sus objetivos estratégicos.
              <br /><br />
              Diseñamos estructuras que optimizan el liderazgo y la gestión, asegurando que las metas se cumplan y los resultados se materialicen. Esto lo logramos estableciendo mecanismos solidos de rendición de cuentas que promueven una cultura de responsabilidad y enfoque en resultados. Nuestro objetivo es transformar planes en acciones concretas.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101547/ebm/empresa-img-9_m0uz8z.png"
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Auditoria financiera"
          subtitle="GARANTIZA LA CONFIABILIDAD DE TU INFORMACIÓN"
          description={
            <>
              Evaluamos la integridad, confiabilidad y consistencia de tu información financiera.
              <br /><br />
              Identificamos desviaciones, riesgos y áreas de mejora en tus procesos contables y de control interno, fortaleciendo la transparencia y la confianza ante accionistas, inversionistas y órganos de gobierno.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101553/ebm/empresa-img-10_kgmhsc.png"
          reverse
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Planeación estratégica"
          subtitle="Transforma tu visión en resultados"
          description={
            <>
              Define el rumbo de tu empresa, estableciendo objetivos claros y diseñando estrategias específicas para alcanzarlos. Mientras la operación diaria mantiene el negocio funcionando hoy, la planeación estratégica lo prepara para el futuro, alineando cada acción con una visión de largo plazo.
              <br /><br />
              Permite a tu empresa anticiparse a las fluctuaciones del mercado, fortalecer su capacidad de respuesta ante los cambios y aprovechar nuevas oportunidades.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101559/ebm/empresa-img-11_qkp4xh.png"
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Definición de indicadores financieros clave"
          subtitle="TOMA EL CONTROL CON LOS DATOS CLAVE DE TU NEGOCIO"
          description={
            <>
              El servicio transforma la estrategia de tu empresa en un sistema de medición accionable. Definiendo los Key Business Drivers que son el verdadero motor de tu negocio.
              <br /><br />
              Entregamos un documento con las especificaciones de cada indicador como su responsable, fuente de datos, periodicidad, formula para su calculo, entre otros.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101563/ebm/empresa-img-12_cj2l63.png"
          reverse
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Ingeniería y diseño de estructura de costos"
          subtitle="OPTIMIZA LA ARQUITECTURA DE TU INFORMACIÓN"
          description={
            <>
              Diseñamos una estructura de costos alineada a tu modelo de negocio y a tus metas de rentabilidad.
              <br /><br />
              Analizamos costos fijos, variables y ocultos para identificar ineficiencias, mejorar márgenes y optimizar la toma de decisiones comerciales.
              <br /><br />
              Entender el verdadero costo de operar es la base para crecer con rentabilidad.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101568/ebm/empresa-img-13_ex5tgd.png"
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Creación de presupuesto maestro"
          subtitle="GESTIONA ACTIVAMENTE TUS SALIDAS DE DINERO"
          description={
            <>
              Estructuramos un Presupuesto Maestro que conecta tu visión con metas financieras claras. Traducimos la estrategia en números concretos, escenarios proyectados y decisiones anticipadas.
              <br /><br />
              Aplicamos la metodología de Presupuesto Base Cero para garantizar disciplina financiera, eficiencia en el uso de recursos y alineación total del equipo directivo hacia resultados medibles y sostenibles.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101575/ebm/empresa-img-14_jvezcv.png"
          reverse
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Proyecciones y análisis de sensibilidad"
          subtitle="La rentabilidad no es casualidad, se diseña"
          description={
            <>
              Consiste en la construcción de proyecciones financieras detalladas que permiten evaluar el desempeño futuro de una empresa bajo distintos escenarios. A través de modelos financieros avanzadas, se analizan variables clave que pueden afectar los resultados del negocio, facilitando la toma de decisiones estratégicas con base en datos realistas y fundamentados.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101580/ebm/empresa-img-15_huhx6z.png"
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Formalización del modelo de negocios"
          subtitle="ESTABLECIENDO LA BASE ESTRATÉGICA"
          description={
            <>
              Proporciona una representación integral del funcionamiento de tu organización y su interacción con el mercado, respondiendo preguntas clave como: ¿Qué ofrece?, ¿Cómo lo proporciona?, ¿A quién se dirige? y ¿Cómo genera ingresos?
              <br /><br />
              Este servicio identifica el núcleo del valor de tu negocio y facilita la toma de decisiones estratégicas sobre su dirección futura en todas las áreas.
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101586/ebm/empresa-img-16_qry2ce.png"
          reverse
        />

        <AlternatingInfoBlock
          titleColor='#0A6274'
          title="Diagnostico financiero"
          subtitle="conoce la efectividad de tu área financiera"
          description={
            <>
              Tu empresa creció pero tu estructura administrativa no evolucionó al mismo ritmo? Nuestro healthcheck financiero es una intervención técnica diseñada para Directores Generales que necesitan claridad y control.
              <br /><br />
              Evaluamos tu empresa en dos dimensiones críticas: auditamos la &quot;salud de tus números&quot; (liquidez, rentabilidad y destructores de valor) y evaluamos el &quot;motor que los produce&quot; (competencias de tu equipo, procesos y tecnología).
            </>
          }
          image="https://res.cloudinary.com/dhoyyqszi/image/upload/v1783101591/ebm/empresa-img-17_oazrha.png"
        />
      </Box>

      {/* Carrusel con artículos de WordPress */}
      <Box sx={{
        backgroundColor: 'white',
        pb: 10,
        pt: 8,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        borderBottom: '1px solid #E0E0E0'
      }}>
        <Typography sx={{
          py: 4,
          color: '#0A6274',
          fontSize: { xs: '1.6rem', md: '2rem' },
          fontWeight: 600,
          textAlign: 'center'
        }}>
          Explora nuestros <b>últimos insights</b>
        </Typography>

        {isLoadingArticles ? (
          <Box sx={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress color="primary" />
          </Box>
        ) : wordpressArticles.length > 0 ? (
          <CarouselArticulos wpData={wordpressArticles} />
        ) : (
          <Typography>No hay artículos disponibles</Typography>
        )}

        <BannerHub></BannerHub>
      </Box>
    </Container>
  );
}